import { CanActivateFn } from '@angular/router';

const MAINTENANCE_MODE = false;

export const maintenanceGuard: CanActivateFn = () => {
  if (MAINTENANCE_MODE) {
    window.location.href = 'https://www.qira.net/maintenance';
    return false;
  }
  return true;
};
